import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import BaseUrl from "../../base-api";
import "./ApplicationStatus.css";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment/moment";
import jsPDF from "jspdf";
import { submitPaymentForm } from "../../Utils/Commons";
import logo from "./../../assets/logo.jpg";
import hkcl from "../../assets/hkcl.png";
import imageCompression from "browser-image-compression";
import spinner from "./../../assets/images/Spinner.gif";
import "jspdf-autotable";

const ApplicationStatus = () => {
  const [applications, setApplications] = useState([]);
  const [statusType, setStatusType] = useState("");
  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize] = useState(10);
  const [exportLoading, setExportLoading] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const { status, title } = location.state || {};
    if (status) {
      setStatusType(status);
      setTitle(title);
    } else {
    }
  }, [location.state]);

  useEffect(() => {
    const fetchApplications = async () => {
      if (!statusType) {
        return;
      }

      try {
        setLoading(true);
        const response = await axios.get(
          `${BaseUrl}/admin/fetchApplicationstatus`,
          {
            headers: {
              Authorization: localStorage.getItem("$3ingT0k3n"),
            },
            params: {
              statusType: statusType,
              page: currentPage,
              size: pageSize,
            },
          }
        );

        setApplications(response.data.content);
        setTotalPages(response.data.totalPages);
      } catch (error) {
        setError("Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    fetchApplications();
  }, [statusType, currentPage, pageSize]);

  const handlePageChange = (direction) => {
    setCurrentPage((prevPage) => {
      if (direction === "next" && prevPage < totalPages - 1) {
        return prevPage + 1;
      } else if (direction === "prev" && prevPage > 0) {
        return prevPage - 1;
      }
      return prevPage;
    });
  };

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  if (loading)
    return (
      <div className="col-xl-12 col-xxl-12 col-sm-12">
        <div className="card me-2">
          <div className="card-header text-center">
            <img src={spinner} alt="Loading..." width={150} />

            <p>Please wait ....</p>
          </div>
        </div>
      </div>
    );
  if (error) return <p>{error}</p>;

  const exportData = async () => {
    try {
      setExportLoading(true);
      // Fetch all applications data using the export API
      const response = await axios.get(
        `${BaseUrl}/admin/exportApplicationsByStatus`,
        {
          headers: {
            Authorization: localStorage.getItem("$3ingT0k3n"),
          },
          params: {
            statusType: statusType,
          },
        }
      );

      const allApplications = response.data; // This should contain all applications for the status

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Registered Candidates");

      // Define worksheet columns
      worksheet.columns = [
        { header: "Candidate Code", key:"candidateCode", width: 15},
        { header: "Candidate Name", key: "candidateName", width: 20 },
        { header: "Father Name", key: "fatherName", width: 20 },
        { header: "Date of Birth", key: "dob", width: 15 },
        { header: "Mobile Number", key: "mobileNumber", width: 15 },
        { header: "Email", key: "email", width: 25 },
        { header: "Country", key: "country", width: 15 },
        { header: "State", key: "state", width: 15 },
        {header : "District", key : "district", width: 15},
        { header: "Address", key: "address", width: 30 },
        { header: "Course", key: "course", width: 30 },
        {header : "Learner Code", key : "learnerCode", width: 30},
        // { header: "Registration Date", key: "registrationDate", width: 15 },
        { header: "Enrolled Date", key: "enrolled", width: 15 },
        { header: "Registration Fee", key: "registrationFee", width: 15 },
        { header: "Course Fee", key: "courseFee", width: 15 },
        { header: "Fee Paid", key: "feePaid", width: 10 },
        {header : "GJU Employee", key : "employee", width: 15},
        { header: "Reference Code", key: "referenceCode", width: 15},
        // Image columns commented out
        // { header: "Photograph", key: "photo", width: 20 },
        // { header: "Signature", key: "sign", width: 20 },
        // { header: "12th Document", key: "12th", width: 20 },
        // { header: "University Document (if any)", key: "uni", width: 25 },
      ];

      // Loop through each data entry from all applications
      for (const t of allApplications) {
        // Prepare course text with child courses
        let courseText = t.course;
        if (t.childCourses && t.childCourses.length > 0) {
          courseText += ": " + t.childCourses.join(", ");
        }

        // Add a row with data
        const row = worksheet.addRow({
          candidateName: t.applicantName,
          fatherName: t.fatherName,
          dob: t.dob,
          mobileNumber: t.mobileNumber,
          email: t.email,
          address: t.address,
          course: courseText, // Updated to include child courses
          enrolled: t.enrolledOn,
          learnerCode: t.learnerCode || "Not Found",
          // registrationDate: t.creationDate || "Null",
          enrolled: t.enrolledOn,
          registrationFee: t.registrationFee || "Null",
          courseFee: t.courseFee || "Null",
          feePaid: t.status === "COURSE_FEE_PAID" ? "Yes" : "No",
          referenceCode: t.referenceCode || "Null",
          candidateCode : t.candidateCode,
          country : t.country,
          state : t.state,
          district : t.district,
          employee : t.employee ? "Yes" : "No",
        });

        // Image processing code commented out
        /*
        // Loop through each document and add images to specific columns
        console.log(`Processing ${t.documents.length} documents for candidate ${t.applicantName}`);
        for (const doc of t.documents) {
          try {
            // Check if document data exists
            if (!doc.data) {
              console.warn(`No data found for document: ${doc.docName}`);
              continue;
            }

            console.log(`Processing document: ${doc.docName}, data length: ${doc.data.length}`);

            // Convert base64 string to buffer using browser-compatible method
            const base64Data = doc.data.includes(',') ? doc.data.split(',')[1] : doc.data;
            const binaryString = atob(base64Data);
            const bytes = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
              bytes[i] = binaryString.charCodeAt(i);
            }

            // Check if buffer was created successfully
            if (bytes.length === 0) {
              console.warn(`Empty buffer for document: ${doc.docName}`);
              continue;
            }

            console.log(`Buffer created successfully for ${doc.docName}, size: ${bytes.length} bytes`);

            // Determine the image extension
            const mimeType = getMimeTypeFromByteArray(bytes);
            const extension = mimeType === "image/jpeg" ? "jpeg" : "png";

            // Add image to the workbook
            const imageId = workbook.addImage({
              buffer: bytes,
              extension: extension,
            });

            // Determine column based on document type (0-based indexing)
            let imageCol;
            switch (doc.docName) {
              case "photo":
                imageCol = 15; // Photograph column (16th column, 0-based)
                break;
              case "sign":
                imageCol = 16; // Signature column (17th column, 0-based)
                break;
              case "12th":
                imageCol = 17; // 12th Document column (18th column, 0-based)
                break;
              default:
                imageCol = 18; // University Document column (19th column, 0-based)
                break;
            }

            console.log(`Adding ${doc.docName} image to column ${imageCol}, row ${row.number - 1}`);

            // Add the image to the specific cell
            worksheet.addImage(imageId, {
              tl: { col: imageCol, row: row.number - 1 }, // Top-left corner of the cell
              ext: { width: 80, height: 80 }, // Proper dimensions for images
              editAs: 'oneCell' // Keep image within cell boundaries
            });

            console.log(`Successfully added ${doc.docName} image`);
          } catch (error) {
            console.error(`Error adding image for document ${doc.docName}:`, error);
          }
        }
        */
      }

      try {
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, `${statusType}.xlsx`);
      } catch (error) {
        console.error("Error writing Excel file:", error);
      }
    } catch (error) {
      console.error("Error exporting applications:", error);
      alert("Failed to export applications. Please try again.");
    } finally {
      setExportLoading(false);
    }
  };
  const getMimeTypeFromByteArray = (buffer) => {
    const arr = new Uint8Array(buffer).subarray(0, 4);
    let header = "";
    for (let i = 0; i < arr.length; i++) {
      header += arr[i].toString(16);
    }

    switch (header) {
      case "89504e47":
        return "image/png";
      case "ffd8ffe0":
      case "ffd8ffe1":
      case "ffd8ffe2":
      case "ffd8ffe3":
      case "ffd8ffe8":
        return "image/jpeg";
      default:
        return "application/octet-stream";
    }
  };
  const compressImage = async (base64Image) => {
    const response = await fetch(base64Image);
    const blob = await response.blob();
    const options = {
      maxSizeMB: 2,
      maxWidthOrHeight: 1200,
      useWebWorker: true,
    };
    try {
      const compressedBlob = await imageCompression(blob, options);
      const compressedBase64 = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(compressedBlob);
        reader.onloadend = () => resolve(reader.result);
      });

      return compressedBase64;
    } catch (error) {
      console.error("Error during image compression", error);
      return base64Image;
    }
  };
  const downloadDetails = async (course) => {
    try {
      let photo = null;
      let sign = null;
      for (const data of course.documents) {
        if (data.data) {
          const base64Image = "data:image/jpeg;base64," + data.data;
          const compressedImageBase64 = await compressImage(base64Image);
          switch (data.docName) {
            case "photo":
              photo = compressedImageBase64;
              break;
            case "sign":
              sign = compressedImageBase64;
              break;
            default:
              break;
          }
        }
      }
      const doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.getWidth();
      const currentTime = new Date().toLocaleString();

      const websiteName =
        "Guru Jambheshwar University of Science & Technology, Hisar";
      const websiteNameWork = "Admission Form";
      const websitelogName = "and";
      const websiteHkcl = "Haryana Knowledge Corporation Limited (HKCL)";
      // const websiteNameWork = "Registration Form";

      const imageWidth = 20;
      const imageHeight = 20;
      const imageX = 10;

      doc.setFont("helvetica");

      const addHeader = () => {
        doc.setFontSize(8).setTextColor("black");
        const generatedTextWidth = doc.getTextWidth(
          `Generated on: ${currentTime}`
        );
        const generatedX = pageWidth - generatedTextWidth - 10;
        doc.text(`Generated on: ${currentTime}`, generatedX, 10);
        doc.text("https://gjuskillcourses.hkcl.in", 10, 10);
      };

      doc.setFontSize(16).setFont("helvetica", "bold");
      addHeader();
      doc.addImage(logo, "JPEG", imageX, 12, imageWidth, imageHeight);

      doc.setFontSize(12).setTextColor("green");

      doc.text(websiteName, imageX + imageWidth + 12, 20);
      doc.text(websitelogName, imageX + imageWidth + 70, 25);
      doc.text(websiteHkcl, imageX + imageWidth + 30, 30);

      const websiteNameWorkWidth = doc.getTextWidth(websiteNameWork);
      const centerX = (pageWidth - websiteNameWorkWidth) / 2;
      const textY = 37;

      doc.text(websiteNameWork, centerX - 4, textY);

      const textHeight = 1.5;
      doc.line(
        centerX - 4,
        textY + textHeight,
        centerX - 3 + websiteNameWorkWidth,
        textY + textHeight
      );
      doc.addImage(
        hkcl,
        "JPEG",
        pageWidth - imageX - imageWidth - 5,
        14,
        imageWidth + 5,
        imageHeight
      );

      doc.setFontSize(12).setTextColor("green");
      doc.text("Personal Details", 15, 40);
      doc.autoTable({
        startY: 44,
        columnStyles: {
          0: { cellWidth: 40 },
          1: { cellWidth: 100 },
        },
        body: [
          [
            { content: "Candidate Name", styles: { fontStyle: "bold" } },
            course.applicantName,
          ],
          [
            { content: "Father Name", styles: { fontStyle: "bold" } },
            course.fatherName,
          ],
          [
            { content: "Mobile Number", styles: { fontStyle: "bold" } },
            course.mobileNumber,
          ],
          [{ content: "Email", styles: { fontStyle: "bold" } }, course.email],
          [
            { content: "Date of Birth", styles: { fontStyle: "bold" } },
            moment(course.dob).format("DD/MM/YYYY"),
          ],
          [
            { content: "Full Address", styles: { fontStyle: "bold" } },
            `${course.address}, ${course.district}, ${course.state}, ${course.country}, ${course.pinCode}`,
          ],
        ],
        theme: "grid",
        styles: {
          lineWidth: 0.1,
          lineColor: [0, 0, 0],
          fontSize: 10,
        },
        didDrawPage: (data) => {
          if (data.pageNumber > 1) {
            addHeader();
          }

          const x = 160;
          const y = 44;
          doc.addImage(photo, "JPEG", x, y, 35, 35);
        },
      });

      doc.setFontSize(12).setTextColor("green");
      doc.text("Course Details", 15, doc.autoTable.previous.finalY + 10);
      doc.setFontSize(16);

      // Prepare bulleted course text
      let enrolledCourseText = course.course;
      if (course.childCourses && course.childCourses.length > 0) {
        enrolledCourseText += ":\n" + course.childCourses.map(c => `- ${c}`).join("\n");
      }

      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 12,
        body: [
          [
            { content: "Enrolled Course", styles: { fontStyle: "bold" } },
            enrolledCourseText,
          ],
        ],
        theme: "grid",
        styles: {
          lineWidth: 0.1,
          lineColor: [0, 0, 0],
          cellPadding: 3,
          fontSize: 10,
        },
        didDrawPage: (data) => {
          if (data.pageNumber > 1) {
            addHeader();
          }
        },
        // Wrap text inside the cell
        columnStyles: {
          1: { cellWidth: 130 }, // adjust width to wrap bullet list
        },
      });


      doc.setFontSize(12).setTextColor("green");
      doc.text(
        "Details of 12th Standard or Equivalent",
        15,
        doc.autoTable.previous.finalY + 10
      );
      doc.setFontSize(16);
      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 15,
        body: [
          [
            { content: "Roll Number", styles: { fontStyle: "bold" } },
            course.rollNumber,
          ],
          [{ content: "Board", styles: { fontStyle: "bold" } }, course.board],
          [
            { content: "Passing Month-Year", styles: { fontStyle: "bold" } },
            course.passingYear,
          ],
          [
            { content: "Marks Obtained", styles: { fontStyle: "bold" } },
            course.marks,
          ],
        ],
        theme: "grid",
        styles: {
          lineWidth: 0.1,
          lineColor: [0, 0, 0],
          fontSize: 10,
        },
        didDrawPage: (data) => {
          if (data.pageNumber > 1) {
            addHeader();
          }
        },
      });
      doc.setFontSize(12).setTextColor("green");
      doc.text("Submitted Documents", 15, doc.autoTable.previous.finalY + 10);
      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 15,
        head: [["Sr. No.", "Name"]],
        body: course.documents.map((item, index) => [index + 1, item.docName]),
        theme: "grid",
        styles: {
          lineWidth: 0.1,
          lineColor: [0, 0, 0],
          halign: "center",
          fontSize: 10,
        },
        columnStyles: {
          0: { cellWidth: 40 },
        },
        didDrawPage: (data) => {
          // Add header on new pages
          if (data.pageNumber > 1) {
            addHeader();
          }
        },
      });
      const paragraphText =
        "I declare that the information provided by me in the application form is true and correct to the best of my knowledge, and I have not concealed any facts. I also confirm that I have carefully read all the guidelines and instructions provided on the admission portal before submitting my application. I also acknowledge the importance of providing correct contact details, as all course-related updates will be sent to my registered mobile number and email ID. I am fully aware that the course once selected cannot be changed under any circumstances and that the course fee, once paid, is non-refundable and non-transferable. I also give my consent to receive updates and course-related information on my registered mobile number/WhatsApp and email ID.";

      const textStartY = doc.autoTable.previous.finalY + 10;
      const signatureStartY = textStartY + 25;

      doc.setFontSize(8);

      const lines = doc.splitTextToSize(paragraphText, 175);

      doc.text(lines, 15, textStartY, { maxWidth: 180, align: "justify" });

      doc
        .setFontSize(8)
        .setFont("helvetica", "underline")
        .setTextColor("black");

      const marginBottom = 10;
      const signatureTextHeight = 10;
      const signatureImageHeight = 10;

      const signatureTextY = doc.internal.pageSize.height - marginBottom;
      const signatureImageY = signatureTextY - signatureImageHeight - 5;

      doc.addImage(
        sign,
        "JPEG",
        pageWidth - 50,
        signatureImageY,
        35,
        signatureImageHeight
      );

      doc.text("(Applicant Signature)", pageWidth - 40, signatureTextY);
      doc.save("Admission Form.pdf");
    } catch (error) {
      console.error("Failed to generate PDF:", error);
      alert("Failed to generate PDF. Please try again.");
    }
  };
  return (
    <div className="table-container d-flex justify-content-between flex-wrap mb-3">
      <h2 className="m-0">{title}</h2>
      {(statusType === "CourseFeePaid" || statusType === "Total") && (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            exportData();
          }}
          style={{ fontSize: "1.2rem", marginTop: "5px" }}
          disabled={exportLoading}
        >
          {exportLoading ? (
            <>
              <img src={spinner} alt="Loading..." width={20} style={{ marginRight: "5px" }} />
              Exporting...
            </>
          ) : (
            "Export"
          )}
        </a>
      )}
      <table>
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Learner Name</th>
            <th>Candidate Code</th>
            <th>Mobile Number</th>
            <th>Date of Birth</th>
            <th>Enrolled Course</th>
            <th>Is GJU Employee?</th>
            <th>Registration Date</th>
            {statusType == "CourseFeePaid" && <th>Admission Form</th>}
          </tr>
        </thead>
        <tbody>
          {applications.map((app, index) => (
            <tr key={index}>
              <td>{index + 1 + currentPage * pageSize}</td>
              <td>
                {app.applicantName}
                <br />
                <b>S/D/o</b> {app.fatherName}
              </td>
              <td>{app.candidateCode}</td>
              <td>{app.mobileNumber}</td>
              <td>{moment(app.dob).format("DD/MM/YYYY")}</td>
              <td>{app.course}</td>
              <td>{app.employee ? "Yes" : "No"}</td>
              <td>{app.enrolledOn}</td>
              {statusType == "CourseFeePaid" && (
                <td>
                  <a
                    style={{ color: "blue" }}
                    href=""
                    onClick={(e) => {
                      e.preventDefault();
                      downloadDetails(app);
                    }}
                  >
                    Print
                  </a>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
      <div className="pagination-controls">
        <button
          onClick={() => handlePageChange("prev")}
          disabled={currentPage === 0}
        >
          Previous
        </button>
        <span>
          Page {currentPage + 1} of {totalPages}
        </span>
        <button
          onClick={() => handlePageChange("next")}
          disabled={currentPage >= totalPages - 1}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default ApplicationStatus;
